export var ProviderType;
(function (ProviderType) {
    ProviderType[ProviderType["Sabre"] = 0] = "Sabre";
    ProviderType[ProviderType["Travelport"] = 1] = "Travelport";
})(ProviderType || (ProviderType = {}));
export var NavitaireCarrier;
(function (NavitaireCarrier) {
    NavitaireCarrier[NavitaireCarrier["Scoot"] = 0] = "Scoot";
    NavitaireCarrier[NavitaireCarrier["Volaris"] = 1] = "Volaris";
})(NavitaireCarrier || (NavitaireCarrier = {}));
//# sourceMappingURL=provider.js.map